export function buildAdminMapViewUrl(
  lat: number,
  lng: number,
  zoom = 14,
  label?: string
): string {
  const params = new URLSearchParams({
    lat: String(lat),
    lng: String(lng),
    zoom: String(zoom),
  });
  if (label) {
    params.set("label", label);
  }
  return `/map/location?${params.toString()}`;
}

export function getCoordinatesFromPinLocation(
  location?: {
    location?: { coordinates?: [number, number] };
  } | null
): { lat: number; lng: number } | null {
  const coords = location?.location?.coordinates;
  if (!coords || coords.length < 2) return null;
  const [lng, lat] = coords;
  if (Number.isNaN(lat) || Number.isNaN(lng)) return null;
  return { lat, lng };
}
